import { CheckCircle2, Lock, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

export type StepState = "completed" | "current" | "locked";

const STEP_TITLES = [
  "Definisci ipotesi rischiose",
  "Crea il protocollo di test",
  "Prepara ed esegui il test",
  "Raccogli evidenze",
  "Verdetto: continua, itera o fermati",
];

export function getStepTitle(n: number) {
  return STEP_TITLES[n - 1] ?? `Step ${n}`;
}

export default function SprintRoadmap({
  completed,
  current,
  active,
  visited = [],
  onSelect,
  readOnly,
}: {
  completed: number[];
  current: number;
  active: number;
  visited?: number[];
  onSelect: (n: number) => void;
  readOnly: boolean;
}) {
  return (
    <div className="space-y-2">
      {STEP_TITLES.map((title, i) => {
        const n = i + 1;
        const isDone = completed.includes(n);
        const isCurrent = !isDone && n === current;
        const isVisited = visited.includes(n);
        const isLocked = !isDone && !isCurrent && !isVisited;
        // In read-only, allow viewing completed only (others stay locked)
        const clickable = readOnly ? isDone : isDone || isCurrent || isVisited;
        const isActive = n === active;

        return (
          <button
            key={n}
            type="button"
            disabled={!clickable}
            onClick={() => clickable && onSelect(n)}
            title={
              !clickable
                ? isLocked
                  ? `Completa prima lo Step ${current} per sbloccare questo step.`
                  : "Step non accessibile in questa modalità."
                : undefined
            }
            className={cn(
              "w-full text-left rounded-xl border p-3 md:p-4 transition-all",
              "flex items-center gap-3",
              isActive
                ? "border-primary/50 bg-primary/5"
                : "border-white/10 bg-white/[0.03] hover:bg-white/[0.06]",
              !clickable && "opacity-50 cursor-not-allowed hover:bg-white/[0.03]"
            )}
          >
            <span
              className={cn(
                "shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-semibold",
                isDone && "bg-emerald-500/20 text-emerald-300",
                isCurrent && "bg-primary text-primary-foreground",
                isLocked && "bg-white/5 text-slate-500"
              )}
            >
              {isDone ? <CheckCircle2 className="h-4 w-4" /> : isLocked ? <Lock className="h-4 w-4" /> : n}
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">
                Step {n} · {title}
              </p>
              <p className="text-[11px] text-slate-400 mt-0.5">
                {isDone ? "Completato" : isCurrent ? "Da fare ora" : "Bloccato"}
              </p>
            </div>
            {!isLocked && <Circle className="h-1.5 w-1.5 fill-current text-slate-600" />}
          </button>
        );
      })}
    </div>
  );
}
